"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBoxInstantResultsWrapper = void 0;
const react_1 = __importStar(require("react"));
const stencil_generated_1 = require("./stencil-generated");
const server_1 = require("react-dom/server");
const client_1 = require("react-dom/client");
/**
 * This component serves as a wrapper for the core AtomicSearchBoxInstantResults.
 *
 * @param props
 * @returns
 */
const SearchBoxInstantResultsWrapper = (props) => {
    const { template } = props, otherProps = __rest(props, ["template"]);
    const instantResultsRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        var _a;
        (_a = instantResultsRef.current) === null || _a === void 0 ? void 0 : _a.setRenderFunction((result, root) => {
            (0, client_1.createRoot)(root).render(template(result));
            return (0, server_1.renderToString)(template(result));
        });
    }, [instantResultsRef]);
    return (react_1.default.createElement(stencil_generated_1.AtomicSearchBoxInstantResults, Object.assign({ ref: instantResultsRef }, otherProps)));
};
exports.SearchBoxInstantResultsWrapper = SearchBoxInstantResultsWrapper;
//# sourceMappingURL=SearchBoxInstantResultsWrapper.js.map